import { createSelector } from '@ngrx/store';

import { selectDetailState } from '@cdba/core/store/reducers';
import { DetailState } from '@cdba/core/store/reducers/detail/detail.reducer';
import { Calculation } from '@cdba/shared/models';

export const getCalculations = createSelector(
  selectDetailState,
  (state: DetailState): Calculation[] => state.calculations.items
);

export const getNumberOfUnauthorizedCalculations = createSelector(
  selectDetailState,
  (state: DetailState): number =>
    state.calculations.numberOfUnauthorizedCalculations
);

export const getMissingCostRoles = createSelector(
  selectDetailState,
  (state: DetailState): string[] => state.calculations.missingCostRoles
);

export const getUnauthorizedPlants = createSelector(
  selectDetailState,
  (state: DetailState): string[] => state.calculations.unauthorizedPlants
);

export const getCalculationsLoading = createSelector(
  selectDetailState,
  (state: DetailState): boolean => state.calculations.loading
);

export const getCalculationsError = createSelector(
  selectDetailState,
  (state: DetailState): string => state.calculations.errorMessage
);

export const getSelectedCalculation = createSelector(
  selectDetailState,
  (state: DetailState): Calculation =>
    state.calculations.selectedCalculation?.calculation
);

export const getSelectedCalculationNodeId = createSelector(
  selectDetailState,
  (state: DetailState): string[] =>
    state.calculations.selectedCalculation?.nodeId
      ? [state.calculations.selectedCalculation.nodeId]
      : undefined
);

export const getSelectedCalculationNodeIds = createSelector(
  selectDetailState,
  (state: DetailState): string[] => state.calculations.selectedNodeIds
);

export const selectCalculationsContext = createSelector(
  selectDetailState,
  (state: DetailState) => ({
    referenceTypeIdentifier: state.selectedReferenceTypeIdentifier,
    type: state.billOfMaterials.type,
  })
);
